import http from "./http_common";

class MembershipService {
    queryString(payload) {
        const QueryString = Object.keys(payload).map((key) => (key && payload[key] && key + "=" + payload[key])).join('&');
        return QueryString;
    }

    getMembershipPlans(payload) {
        const queryString = this.queryString(payload);
        return http.get(`/MembershipMaster/list?${queryString}`);
    }

    getMembershipDetails(payload) {
        const queryString = this.queryString(payload);
        return http.get(`/MembershipServiceDetails/list?${queryString}`);
    }

    getMemberships(payload) {
        const queryString = Object.keys(payload).map((key) => (key && (payload[key] !== null || payload[key] !== undefined) && key + "=" + payload[key])).join('&');
        return http.get(`/PatientMembership/list/filter?${queryString}`);
    }

}
export default new MembershipService();